import * as Events from '@core/events';

export const handler = ({
  field,
  data,
}: Pick<Events.TEventInformation<unknown>, 'field' | 'data'>) => {
  field.data.keyup = true;
  field.value = data.parsedEventValue;
};
